// Маппер для данных секторов дашборда: преобразует полученный с сервера JSON

import DashboardMapperChart from "./dashboard-mapper-chart";

// в струкруру для отображения с лейблами, графиками и числами
const DashboardMappersSectors = (apiData) => {
  const get = (obj, path, fallback = 0) => path.reduce((acc, key) => (acc && acc[key] != null ? acc[key] : fallback), obj);

  const config = {
    visits: {
      title: 'Визиты',
      stats: [
        { label: 'Сегодня', path: ['visits', 'today'] },
        { label: 'Сейчас', path: ['visits', 'openToday'] },
        { label: 'Ранее', path: ['visits', 'openEarlier'] },
      ],
      chart: { title: 'Посетители сегодня' },
    },
    records: {
      title: 'Записи',
      stats: [
        { label: 'Сегодня', path: ['records', 'today'] },
        { label: 'Сейчас', path: ['records', 'now'] },
        { label: 'Отмена', path: ['records', 'cancelled'] },
      ],
      chart: { title: 'Записи на день' },
    },
    clients: {
      title: 'Клиенты',
      stats: [
        { label: 'Всего', path: ['clients', 'total'] },
        { label: 'Активных', path: ['clients', 'active'] },
        {
          label: 'Спящих',
          compute: data => {
            const total = get(data, ['clients', 'total']);
            const active = get(data, ['clients', 'active']);
            if (typeof total === 'number' && typeof active === 'number') {
              return total - active;
            }
            return "Неизв.";
          }
        },
      ],
      newToday: { label: 'Сегодня новых - ', path: ['clients', 'new'] },
      chart: { title: 'Новые клиенты за 30 дн' },
    },
    finance: {
      title: 'Выручка',
      stats: [
        { label: 'Платежи', path: ['finance', 'today'] },
        { label: 'Абонементы\nПакеты', path: ['finance', 'membership'] },
        { label: 'Товары\nУслуги', path: ['finance', 'service'] },
      ],
      chart: { title: 'Оплаты за 30 дней' },
    },
    dialogs: {
      labels: ['Новых', 'Всего', 'Мои'],
      new: { path: ['dialogs', 'new'], fallback: 0 },
      total: { path: ['dialogs', 'total'], fallback: 0 },
      my: { path: ['dialogs', 'my'], fallback: 0 },
    },
  };

  return {
    visits: {
      title: config.visits.title,
      stats: config.visits.stats.map(stat => ({
        label: stat.label,
        value: get(apiData, stat.path),
      })),
      chart: {
        title: 'Посетители сегодня',
        option: DashboardMapperChart('visits', apiData) || {},
      },
    },
    records: {
      title: config.records.title,
      stats: config.records.stats.map(stat => ({
        label: stat.label,
        value: get(apiData, stat.path),
      })),
      chart: {
        title: 'Записи на день',
        option: DashboardMapperChart('records', apiData) || {},
      },
    },
    clients: {
      title: config.clients.title,
      stats: config.clients.stats.map(stat => ({
        label: stat.label,
        value: stat.compute ? stat.compute(apiData) : get(apiData, stat.path),
      })),
      newToday: {
        label: config.clients.newToday.label,
        value: get(apiData, config.clients.newToday.path),
      },
      chart: {
        title: 'Новые клиенты за 30 дн',
        option: DashboardMapperChart('clients', apiData) || {},
      },
    },
    finance: {
      title: config.finance.title,
      stats: config.finance.stats.map(stat => ({
        label: stat.label,
        value: get(apiData, stat.path),
      })),
      chart: {
        title: 'Оплаты за 30 дней',
        option: DashboardMapperChart('finance', apiData) || {},
      },
    },
    dialogs: {
      new: get(apiData, config.dialogs.new.path),
      total: get(apiData, config.dialogs.total.path),
      my: get(apiData, config.dialogs.my.path, config.dialogs.my.fallback),
      labels: config.dialogs.labels,
    },
  };
};

export default DashboardMappersSectors;